export default __webpack_public_path__ + "static/TransformationImg-dea7e08bc807d246753e9282eb37a8fa.png";